import type { TarefaStatus } from "@/services/tarefas";

export interface StatusCardTheme {
  border: string;
  left: string;
  bg: string;
  text: string;
  dot: string;
  dotRing: string;
  label: string;
}

export const STATUS_CARD_THEME: Record<TarefaStatus, StatusCardTheme> = {
  pendente: {
    border: "border-slate-200",
    left: "border-l-slate-300",
    bg: "bg-white",
    text: "text-slate-700",
    dot: "bg-slate-300",
    dotRing: "ring-slate-300",
    label: "Pendente",
  },
  em_andamento: {
    border: "border-blue-100",
    left: "border-l-blue-500",
    bg: "bg-blue-50/70",
    text: "text-blue-900",
    dot: "bg-blue-500",
    dotRing: "ring-blue-400",
    label: "Em andamento",
  },
  parada: {
    border: "border-amber-100",
    left: "border-l-amber-500",
    bg: "bg-amber-50/70",
    text: "text-amber-900",
    dot: "bg-amber-500",
    dotRing: "ring-amber-400",
    label: "Parada",
  },
  concluida: {
    border: "border-emerald-100",
    left: "border-l-emerald-500",
    bg: "bg-emerald-50/70",
    text: "text-emerald-900",
    dot: "bg-emerald-500",
    dotRing: "ring-emerald-400",
    label: "Concluída",
  },
};

/** Botões rápidos no card (azul, laranja, verde). */
export const QUICK_STATUS_BUTTONS: Array<{
  status: TarefaStatus;
  title: string;
}> = [
  { status: "em_andamento", title: "Em andamento" },
  { status: "parada", title: "Parada" },
  { status: "concluida", title: "Concluída" },
];

export function splitTarefasAtivasConcluidas<T extends { status: TarefaStatus; horario?: string | null }>(
  tasks: T[],
): { ativas: T[]; concluidas: T[] } {
  const ativas: T[] = [];
  const concluidas: T[] = [];
  for (const t of tasks) {
    if (t.status === "concluida") concluidas.push(t);
    else ativas.push(t);
  }
  const byHorario = (a: T, b: T) => {
    const ha = a.horario ?? "99:99";
    const hb = b.horario ?? "99:99";
    return ha.localeCompare(hb);
  };
  ativas.sort(byHorario);
  concluidas.sort(byHorario);
  return { ativas, concluidas };
}
